import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { motion } from "framer-motion";
import {
  FaInstagram,
  FaFacebookF,
  FaTwitter,
  FaTiktok,
  FaMapMarkerAlt,
  FaPhone,
  FaEnvelope,
  FaClock,
  FaChevronRight,
  FaPaperPlane,
} from "react-icons/fa";

const Footer = () => {
  const handleSubmit = (e) => {
    e.preventDefault();
    // In a real application, you would implement the newsletter subscription here
    // For demo purposes, just reset the form
    e.target.reset();
    alert("Thank you for subscribing to our newsletter!");
  };

  return (
    <FooterWrapper>
      <FooterDecoration />

      <Container>
        <FooterContent>
          <FooterColumn>
            <LogoContainer>
              <LogoImage
                src="/images/bmg_logo.png"
                alt="Baltimore Grillz Logo"
              />
            </LogoContainer>
            <FooterText>
              Baltimore Grillz & Custom Jewelry specializes in creating premium
              custom grillz and jewelry pieces that reflect your unique style
              and personality.
            </FooterText>
            <SocialLinks>
              <SocialLink
                href="https://www.instagram.com/bmoregrillz?igsh=MXNhb3dzNWVjeHNoMw=="
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{
                  y: -5,
                  boxShadow: "0 10px 15px rgba(255, 215, 0, 0.3)",
                }}
              >
                <FaInstagram />
              </SocialLink>
              <SocialLink
                href="#"
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{
                  y: -5,
                  boxShadow: "0 10px 15px rgba(255, 215, 0, 0.3)",
                }}
              >
                <FaFacebookF />
              </SocialLink>
              <SocialLink
                href="#"
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{
                  y: -5,
                  boxShadow: "0 10px 15px rgba(255, 215, 0, 0.3)",
                }}
              >
                <FaTwitter />
              </SocialLink>
              <SocialLink
                href="#"
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{
                  y: -5,
                  boxShadow: "0 10px 15px rgba(255, 215, 0, 0.3)",
                }}
              >
                <FaTiktok />
              </SocialLink>
            </SocialLinks>
          </FooterColumn>

          <FooterColumn>
            <FooterTitle>Quick Links</FooterTitle>
            <FooterLinks>
              <FooterLinkItem>
                <FooterLink to="/">
                  <FaChevronRight /> Home
                </FooterLink>
              </FooterLinkItem>
              <FooterLinkItem>
                <FooterLink to="/about">
                  <FaChevronRight /> About Us
                </FooterLink>
              </FooterLinkItem>
              <FooterLinkItem>
                <FooterLink to="/services">
                  <FaChevronRight /> Services
                </FooterLink>
              </FooterLinkItem>
              <FooterLinkItem>
                <FooterLink to="/gallery">
                  <FaChevronRight /> Gallery
                </FooterLink>
              </FooterLinkItem>
              <FooterLinkItem>
                <FooterLink to="/contact">
                  <FaChevronRight /> Contact
                </FooterLink>
              </FooterLinkItem>
            </FooterLinks>
          </FooterColumn>

          <FooterColumn>
            <FooterTitle>Services</FooterTitle>
            <FooterLinks>
              <FooterLinkItem>
                <FooterLink to="/services">
                  <FaChevronRight /> Custom Grillz
                </FooterLink>
              </FooterLinkItem>
              <FooterLinkItem>
                <FooterLink to="/services">
                  <FaChevronRight /> Custom Jewelry
                </FooterLink>
              </FooterLinkItem>
              <FooterLinkItem>
                <FooterLink to="/services">
                  <FaChevronRight /> Restoration & Repair
                </FooterLink>
              </FooterLinkItem>
              <FooterLinkItem>
                <FooterLink to="/services">
                  <FaChevronRight /> Consultations
                </FooterLink>
              </FooterLinkItem>
              <FooterLinkItem>
                <FooterLink to="/services">
                  <FaChevronRight /> Cleaning & Maintenance
                </FooterLink>
              </FooterLinkItem>
            </FooterLinks>
          </FooterColumn>

          <FooterColumn>
            <FooterTitle>Contact Information</FooterTitle>
            <ContactItem>
              <ContactIcon>
                <FaMapMarkerAlt />
              </ContactIcon>
              <ContactText>
                <strong>Our Location</strong>
                <span>6901 Security Blvd, Baltimore, MD 21244</span>
              </ContactText>
            </ContactItem>

            <ContactItem>
              <ContactIcon>
                <FaPhone />
              </ContactIcon>
              <ContactText>
                <strong>Phone Number</strong>
                <ContactLink href="tel:+13015388046">
                  (301) 538-8046
                </ContactLink>
              </ContactText>
            </ContactItem>

            <ContactItem>
              <ContactIcon>
                <FaEnvelope />
              </ContactIcon>
              <ContactText>
                <strong>Email Address</strong>
                <ContactLink href="mailto:baltimoregrillz@gmail.com">
                  baltimoregrillz@gmail.com
                </ContactLink>
              </ContactText>
            </ContactItem>

            <ContactItem>
              <ContactIcon>
                <FaClock />
              </ContactIcon>
              <ContactText>
                <strong>Business Hours</strong>
                <span>Mon-Thu: 11AM - 7PM</span>
                <span>Fri-Sat: 11AM - 8PM</span>
                <span>Sun: 12PM - 6PM</span>
              </ContactText>
            </ContactItem>
          </FooterColumn>

          <FooterColumn>
            <FooterTitle>Newsletter</FooterTitle>
            <FooterText>
              Subscribe to our newsletter to receive updates on new designs,
              promotions, and events.
            </FooterText>
            <NewsletterForm onSubmit={handleSubmit}>
              <NewsletterInput type="email" placeholder="Your Email" required />
              <NewsletterButton
                type="submit"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                <FaPaperPlane />
              </NewsletterButton>
            </NewsletterForm>
          </FooterColumn>
        </FooterContent>

        <FooterBottom>
          <CopyrightText>
            &copy; {new Date().getFullYear()} Baltimore Grillz & Custom Jewelry.
            All Rights Reserved.
          </CopyrightText>
        </FooterBottom>
      </Container>

      <BackToTop
        href="#top"
        whileHover={{ y: -5, boxShadow: "0 10px 15px rgba(255, 215, 0, 0.3)" }}
      >
        <span>↑</span>
      </BackToTop>
    </FooterWrapper>
  );
};

// Styled Components
const FooterWrapper = styled.footer`
  background-color: var(--darker-bg);
  position: relative;
  padding: var(--spacing-xl) 0 var(--spacing-md);
  margin-top: var(--spacing-xl);
`;

const FooterDecoration = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 3px;
  background: var(--gold-gradient);
`;

const Container = styled.div`
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 var(--spacing-md);
  position: relative;
  z-index: var(--z-base);

  @media (max-width: 768px) {
    padding: 0 var(--spacing-sm);
  }
`;

const FooterContent = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: var(--spacing-lg);
  margin-bottom: var(--spacing-lg);
`;

const FooterColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

const LogoContainer = styled.div`
  margin-bottom: var(--spacing-md);
`;

const LogoImage = styled.img`
  width: 180px;
  height: auto;
  filter: drop-shadow(0 0 8px rgba(255, 215, 0, 0.3));
`;

const FooterText = styled.p`
  color: #888;
  font-size: 0.95rem;
  line-height: 1.7;
  margin-bottom: var(--spacing-md);
`;

const SocialLinks = styled.div`
  display: flex;
  gap: var(--spacing-sm);
`;

const SocialLink = styled(motion.a)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  background: rgba(255, 215, 0, 0.05);
  border-radius: 50%;
  color: var(--gold);
  font-size: 1.1rem;
  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  border: 1px solid rgba(255, 215, 0, 0.15);

  &:hover {
    background: var(--gold-gradient);
    color: var(--black);
    border-color: transparent;
    transform: translateY(-3px) rotate(-5deg);
    box-shadow: 0 10px 20px rgba(255, 215, 0, 0.3);
  }
`;

const FooterTitle = styled.h3`
  color: var(--gold);
  font-size: 1.2rem;
  text-transform: uppercase;
  margin-bottom: var(--spacing-md);
  letter-spacing: 1.5px;
  position: relative;
  padding-bottom: var(--spacing-xs);

  &:after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 40px;
    height: 2px;
    background: var(--gold);
  }
`;

const FooterLinks = styled.ul`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xs);
`;

const FooterLinkItem = styled.li`
  transition: var(--transition-fast);

  &:hover {
    transform: translateX(5px);
  }
`;

const FooterLink = styled(Link)`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #d0d0d0;
  font-size: 0.95rem;
  transition: var(--transition-fast);

  svg {
    color: var(--gold);
    font-size: 0.8rem;
  }

  &:hover {
    color: var(--gold);
  }
`;

const ContactItem = styled.div`
  display: flex;
  margin-bottom: var(--spacing-sm);
  align-items: flex-start;
`;

const ContactIcon = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(255, 215, 0, 0.05);
  border: 1px solid rgba(255, 215, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: var(--spacing-sm);
  color: var(--gold);
  font-size: 1rem;
  transition: var(--transition-fast);
  flex-shrink: 0;

  ${ContactItem}:hover & {
    background: var(--gold-gradient);
    color: var(--black);
    transform: scale(1.1);
  }
`;

const ContactText = styled.div`
  display: flex;
  flex-direction: column;

  strong {
    color: white;
    font-size: 0.95rem;
    margin-bottom: 4px;
  }

  span {
    color: #888;
    font-size: 0.9rem;
    display: block;
    line-height: 1.5;
  }
`;

const ContactLink = styled.a`
  color: #888;
  font-size: 0.9rem;
  transition: var(--transition-fast);

  &:hover {
    color: var(--gold);
  }
`;

const NewsletterForm = styled.form`
  position: relative;
  margin-top: var(--spacing-sm);
`;

const NewsletterInput = styled.input`
  width: 100%;
  padding: 16px 22px;
  padding-right: 65px;
  background-color: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 215, 0, 0.15);
  color: white;
  border-radius: var(--radius-lg);
  font-size: 0.95rem;
  transition: all 0.3s ease;

  &:focus {
    outline: none;
    border-color: var(--gold);
    background-color: rgba(255, 255, 255, 0.06);
    box-shadow: 0 0 20px rgba(255, 215, 0, 0.15);
  }

  &::placeholder {
    color: #666;
  }
`;

const NewsletterButton = styled(motion.button)`
  position: absolute;
  right: 6px;
  top: 6px;
  width: 46px;
  height: 46px;
  border-radius: var(--radius-md);
  background: var(--gold-gradient);
  color: var(--black);
  cursor: pointer;
  border: none;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    box-shadow: 0 5px 15px rgba(255, 215, 0, 0.4);
    transform: translateX(2px);
  }
`;

const FooterBottom = styled.div`
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  padding-top: var(--spacing-md);
  text-align: center;
`;

const CopyrightText = styled.p`
  color: #666;
  font-size: 0.9rem;

  a {
    color: var(--gold);
    transition: var(--transition-fast);

    &:hover {
      color: var(--light-gold);
    }
  }
`;

const BackToTop = styled(motion.a)`
  position: fixed;
  bottom: 30px;
  right: 30px;
  width: 52px;
  height: 52px;
  background: rgba(0, 0, 0, 0.8);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--gold);
  font-size: 1.3rem;
  text-decoration: none;
  z-index: var(--z-elevated);
  border: 1px solid rgba(255, 215, 0, 0.3);
  backdrop-filter: blur(10px);
  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);

  &:hover {
    background: var(--gold-gradient);
    color: var(--black);
    border-color: transparent;
    box-shadow: 0 10px 25px rgba(255, 215, 0, 0.4);
    transform: translateY(-5px);
  }

  @media (max-width: 768px) {
    width: 44px;
    height: 44px;
    bottom: 20px;
    right: 20px;
    font-size: 1.1rem;
  }
`;

export default Footer;
